import { render, staticRenderFns } from "./Tips.vue?vue&type=template&id=c1f02cc2&scoped=true&"
import script from "./Tips.vue?vue&type=script&lang=js&"
export * from "./Tips.vue?vue&type=script&lang=js&"
import style0 from "./Tips.vue?vue&type=style&index=0&id=c1f02cc2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1f02cc2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/hanzhu/nutstore-webpages/js_src_vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c1f02cc2')) {
      api.createRecord('c1f02cc2', component.options)
    } else {
      api.reload('c1f02cc2', component.options)
    }
    module.hot.accept("./Tips.vue?vue&type=template&id=c1f02cc2&scoped=true&", function () {
      api.rerender('c1f02cc2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/page_listary_landing/components/AppSale/Tips.vue"
export default component.exports